import { NamedProperty } from "sprint-common-web";

import { EncodeSpecificationType } from "../../admin/encode-specification/context/EncodeSpecificationItem";
import { EncodeSpecificationLookupResponse } from "../api/orders-api/encode-specification/responses/GetEncodeSpecificationsLookupResponse";

export type EncodeSpecification = {
    id: string;
    name: string;
    type: EncodeSpecificationType;
    targetAspectRatio: NamedProperty;
};

export const mapToEncodeSpecification = (response: EncodeSpecificationLookupResponse): EncodeSpecification => ({
    id: response.id,
    name: response.name,
    type: response.type,
    targetAspectRatio: response.targetAspectRatio
});
